import _ from "lodash";

// Shared by Machine Management and Admin Tools -> RWO Settings (the "add machines" control).
// Mirrors RepairService.MaxMachinesPerAdd - the server refuses a larger count with the same sentence.
const MAX_MACHINES_PER_ADD = 50;
const WHOLE_NUMBER = /^\d+$/;
const ADD_COUNT_MESSAGE = `Enter how many machines to add - from 1 to ${MAX_MACHINES_PER_ADD}.`;

// "Added machines 5, 6 and 7 to DS10-E Winder." / "Added machine 5 to DS10-E Winder."
function addedMachinesMessage(numbers, typeName) {
   const list = numbers.length > 1
      ? `${_.initial(numbers).join(", ")} and ${_.last(numbers)}`
      : `${numbers[0]}`;
   return `Added machine${numbers.length > 1 ? "s" : ""} ${list} to ${typeName}.`;
}

// The whole-number count from the input text, or 0 when it is not a valid 1 to MAX_MACHINES_PER_ADD.
function parseAddCount(value) {
   const text = `${value}`.trim();
   const count = Number(text);
   return WHOLE_NUMBER.test(text) && count >= 1 && count <= MAX_MACHINES_PER_ADD ? count : 0;
}

const rwoMachines = {
   ADD_COUNT_MESSAGE,
   MAX_MACHINES_PER_ADD,
   addedMachinesMessage,
   parseAddCount
};

export default rwoMachines;
